import { render, staticRenderFns } from "./tuikuan.vue?vue&type=template&id=a6cd4ad6&scoped=true"
import script from "./tuikuan.vue?vue&type=script&lang=js"
export * from "./tuikuan.vue?vue&type=script&lang=js"
import style0 from "./tuikuan.vue?vue&type=style&index=0&id=a6cd4ad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cd4ad6",
  null
  
)

export default component.exports